import styled from 'styled-components';
import Colors from '../../colors';

const HouseSmartStyles = styled.div`
  .spacer {
    margin-bottom: 70px;
    @media only screen and (max-width: 775px) {
      margin-bottom: 50px;
    }
  }

  .page-link {
    color: #4e5255 !important;
  }

  .sub-note {
    font-size: 14px;
  }

  .link-btn {
    color: ${Colors.primary.white.standard} !important;
    background: ${Colors.primary.claytonBlue.standard};
    border-radius: 2px;
    padding: 17px;
    text-align: center;
    font: 600 14px/100% 'source-sans-pro', sans-serif;
    text-transform: uppercase;
    width: 190px;
    height: 50px;
    letter-spacing: 1px;
    line-height: 16px;
    letter-spacing: 1px;
    text-decoration: none !important;
    margin-top: 29px !important;
    display: block;

    &:hover {
      opacity: 0.9;
    }
  }
`;

export default HouseSmartStyles;
